// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"n2-z","vrsnlCrossSiteLabel":"o2-z"};